import { createContext, useContext, useEffect, useMemo, useState } from "react";
import { getProduct } from "../lib/products";

const CartContext = createContext(null);
const KEY = "danobars_cart_v1";

const load = () => {
  try {
    const v = JSON.parse(localStorage.getItem(KEY));
    return Array.isArray(v) ? v.filter((i) => getProduct(i?.slug)?.variants?.some((x) => x.id === i.variant)) : [];
  } catch {
    return [];
  }
};

export const CartProvider = ({ children }) => {
  const [items, setItems] = useState(load);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    localStorage.setItem(KEY, JSON.stringify(items));
  }, [items]);

  const add = (product, variant, qty) => {
    const key = `${product.slug}:${variant.id}`;
    setItems((prev) => {
      const found = prev.find((i) => i.key === key);
      if (found) return prev.map((i) => (i.key === key ? { ...i, qty: Math.min(99, i.qty + qty) } : i));
      return [...prev, { key, slug: product.slug, name: product.name, image: product.image, variant: variant.id, variantLabel: variant.label, price: variant.price, qty }];
    });
    setOpen(true);
  };

  const setQty = (key, qty) =>
    setItems((prev) => (qty < 1 ? prev.filter((i) => i.key !== key) : prev.map((i) => (i.key === key ? { ...i, qty: Math.min(99, qty) } : i))));

  const clear = () => setItems([]);

  const value = useMemo(() => {
    const count = items.reduce((s, i) => s + i.qty, 0);
    const subtotal = items.reduce((s, i) => s + i.qty * i.price, 0);
    return { items, count, subtotal, add, setQty, clear, open, setOpen };
  }, [items, open]);

  return <CartContext.Provider value={value}>{children}</CartContext.Provider>;
};

export const useCart = () => useContext(CartContext);
